import PARENT_E2E_PREFIX from '../e2ePrefix';

const E2E_PREFIX = `${PARENT_E2E_PREFIX}-invoice-kind-detail`;

export default E2E_PREFIX;
